/**
 * custom hook to check visibility of a DOM element
 * @param {Obj} ref DOM element
 * @param {Number} visibilityThreshold indicate at what percentage of the target's
 * @param {Function} callback
 * visibility the observer's callback should be executed
 * @returns function
 */
// eslint-disable-next-line import/prefer-default-export
export function useOnScreen (ref, visibilityThreshold, callback) {
  const observer = new IntersectionObserver(
    ([entry]) => {
      callback(entry.isIntersecting)
    },
    { visibilityThreshold },
  )

  if (ref.current) {
    observer.observe(ref.current)
  }

  return () => {
    if (ref.current) {
      observer.unobserve(ref.current)
    }
  }
}
